import { render, staticRenderFns } from "./TipsProfile.vue?vue&type=template&id=06e75cc4&scoped=true&"
import script from "./TipsProfile.vue?vue&type=script&setup=true&lang=ts&"
export * from "./TipsProfile.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./TipsProfile.vue?vue&type=style&index=0&id=06e75cc4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e75cc4",
  null
  
)

export default component.exports